module.exports = __webpack_public_path__ + "static/img/myl.c60f942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/myl.png
// module id = rErL
// module chunks = 4